import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';

/**
 * Custom hook to check if the user is authenticated and redirect to login if not
 * @param redirectPath The path to redirect to if not authenticated (default: '/login')
 * @returns A boolean indicating if the user is authenticated
 */
export const useAuthCheck = (redirectPath: string = '/login'): boolean => {
  const navigate = useNavigate();
  const authenticated = isAuthenticated();

  useEffect(() => {
    if (!authenticated) {
      navigate(redirectPath);
    }
  }, [authenticated, navigate, redirectPath]);

  return authenticated;
};

export default useAuthCheck; 